import { loadImageAsBase64 } from "../pdfUtils";

export async function drawReportHeader(pdf, alerts, timestamp) {
  const [date, time] = timestamp.split(" ");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 40;
  const boxHeight = 80;
  const boxY = margin;

  const col1Width = (pageWidth - margin * 2) * 0.45;
  const col2Width = (pageWidth - margin * 2) * 0.15;
  const col3Width = (pageWidth - margin * 2) * 0.4;

  const leftX = margin;
  const centerX = leftX + col1Width;
  const rightX = centerX + col2Width;

  const hasAlarms = alerts && alerts.length > 0;
  const statusText = hasAlarms ? "KO" : "OK";
  const statusImageUrl = hasAlarms
    ? "/images/cross_icon.png"
    : "/images/check_icon.png";
  const statusImageData = await loadImageAsBase64(statusImageUrl);

  // Cuadro izquierdo
  pdf.rect(leftX, boxY, col1Width, boxHeight);
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "bold");
  pdf.text("INFORME DE TRAZABILIDAD CORREOS FRÍO", leftX + 5, boxY + 15);
  pdf.setFont("helvetica", "normal");
  pdf.text(
    `Archivo creado el ${date.replace(/-/g, "/")} a las ${time}`,
    leftX + 5,
    boxY + 50
  );

  // Imagen central
  const imageUrl = "/images/logo-report.png";
  const imageData = await loadImageAsBase64(imageUrl);
  const imageWidth = 65;
  const imageHeight = 75;
  const imageX = centerX + (col2Width - imageWidth) / 2;
  const imageY = boxY + (boxHeight - imageHeight) / 2;
  pdf.addImage(imageData, "PNG", imageX, imageY, imageWidth, imageHeight);

  // Cuadro derecho con símbolo
  pdf.rect(rightX, boxY, col3Width, boxHeight);
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  pdf.text("Símbolo de alarma OK o KO", rightX + 5, boxY + 15);
  pdf.text("Check verde: Sin alarma", rightX + 5, boxY + 30);

  pdf.setFontSize(8);
  pdf.text("Estado Alarma:", rightX + 5, boxY + 50);

  const statusBoxWidth = 30;
  const iconBoxWidth = 25;
  const boxHeightStatus = 20;
  const boxTop = boxY + 55;
  const boxLeft = rightX + 5;

  pdf.setFillColor(255, 255, 255);
  pdf.setFontSize(10);
  pdf.rect(boxLeft, boxTop, statusBoxWidth, boxHeightStatus);
  pdf.text(statusText, boxLeft + 8, boxTop + 14);

  pdf.rect(boxLeft + statusBoxWidth, boxTop, iconBoxWidth, boxHeightStatus);

  const iconWidth = 12;
  const iconHeight = 12;
  const iconX = boxLeft + statusBoxWidth + (iconBoxWidth - iconWidth) / 2;
  const iconY = boxTop + (boxHeightStatus - iconHeight) / 2;

  pdf.addImage(statusImageData, "PNG", iconX, iconY, iconWidth, iconHeight);
}
